'use strict';

function CompanyInfoService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/info', {}, {
    'update': { method:'PUT' }
  });
}

angular.module('dokiv')
  .factory('CompanyInfoService', ['$resource', 'config', CompanyInfoService]);




//////////////////
// WEBPACK FOOTER
// ./scripts/company/CompanyInfoService.js
// module id = 24
// module chunks = 0